import Slider from 'react-slick';
import React, { useRef } from 'react';

import { StyledSlider } from './styled';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const AutoSlider = ({
    children,
    sliderWidth = 336,
    paddingBtwSlides = 12,
}: {
    children: React.ReactNode;
    sliderWidth?: number;
    paddingBtwSlides?: number;
}) => {
    const sliderRef = useRef<Slider>(null);
    const totalSlides = React.Children.count(children);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        swipe: true,
        arrows: false,
        pauseOnHover: false,
        afterChange: (current: number) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }

            if (current === totalSlides - 1) {
                timeoutRef.current = setTimeout(() => {
                    sliderRef.current?.slickGoTo(0);
                    timeoutRef.current = null;
                }, 5000);
            }
        },
    };

    return (
        <StyledSlider ref={sliderRef} {...settings} sliderWidth={sliderWidth} paddingBtwSlides={paddingBtwSlides}>
            {children}
        </StyledSlider>
    );
};

export default AutoSlider;
